export default "__VITE_ASSET__Cyt3gJdc__"